import Api from '@/services/ServiceBase'
const path = 'clients'

export default {
  addUpdate(client) {
    return Api().post(path, client)
  },
  list(name, page,externalID) {
    return Api().get(path, {
      params: {
        name,
        page,
        externalID
      }
    })
  },
  show(id) {
    return Api().get(path + `/${id}`)
  },
  delete(clientId) {
    return Api().delete(path + `/${clientId}`)
  }
}
